import { useState } from 'react';
import Dropdown from '../ui/Dropdown';
import Input from '../ui/Input';

const CUSTOM_VALUE = '__custom__';

/**
 * v1.18.0 — admin tag picker for Add Template / Attach Document. Per the
 * user's explicit fallback (the full backend tag enum couldn't be
 * confirmed against a live response this session): offers the known tags
 * from KYC_OTHER_DOCUMENT_TAGS as a dropdown, cross-checked by the caller
 * against tags that don't already have a current template, PLUS a free-text
 * option so an admin is never blocked by this list being incomplete — the
 * server's 422 is the real source of truth either way.
 */
export default function KycTagSelect({ value, onChange, knownTags, label = 'Document tag', error }) {
  const isKnown = knownTags.some((t) => t.value === value);
  const [customMode, setCustomMode] = useState(value ? !isKnown : false);

  const options = [...knownTags, { value: CUSTOM_VALUE, label: 'Custom tag…' }];

  if (customMode) {
    return (
      <div>
        <Input
          label={label}
          placeholder="e.g. investment_agreement"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          error={error}
        />
        {knownTags.length > 0 && (
          <button
            type="button"
            className="mt-1.5 text-xs text-accent hover:underline"
            onClick={() => {
              setCustomMode(false);
              onChange('');
            }}
          >
            Choose from known tags instead
          </button>
        )}
      </div>
    );
  }

  return (
    <Dropdown
      label={label}
      placeholder="Select a tag"
      options={options}
      value={value}
      error={error}
      onChange={(v) => {
        if (v === CUSTOM_VALUE) {
          setCustomMode(true);
          onChange('');
        } else {
          onChange(v);
        }
      }}
    />
  );
}
